export const DEFAULT_CREDIT_CREDENTIALS_FORM = {
	creditReportIdentifier: "", // creditReportIdentifier
	clientID: "", // clientID, optional
	creditVendor: "", // partner's/vendor's name
	productName: "", // partner's/vendor's product name
	providerId: "", // Credit vendor id - partner's/vendor's id
	subscriberId: "", // optional
	userName: "", // loginId
	password: "", // password
	reportOn: "",
	productCode: "", // optional
};

export const CREDIT_REISSUE_CONSTANTS = {
	REISSUE: "Reissue",
	MANUAL: "Manual",
};

export const CREDIT_REISSUE_REPORT_ON_CONSTANTS = {
	JOINT: "Joint",
	INDIVIDUAL: "Individual",
};

export const CLIENT_ID_ENABLED_PARTNERS = ["Informative Research"];

// LC-CRED-001: some vendors (e.g. Advantage Credit with bad credentials) return
// 200 + "pending" indefinitely instead of ever resolving to success/error, so
// status polling is capped rather than continuing forever.
export const CREDIT_REISSUE_STATUS_POLL_INTERVAL_MS = 2000;
export const MAX_CREDIT_REISSUE_STATUS_POLL_ATTEMPTS = 30;
